export default __webpack_public_path__ + "static/media/mushroom-parent-and-child--front.83815fe5.jpg";